import { useApi } from "./useApi";
import { web } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/** Parents join as player-level members in the mobile app; the website labels them and keeps them view-only. */
export function useFamilyRole() {
  const { membership } = useAuth();
  const { data, loading } = useApi(membership?.role === "player" && "/me/family-roles", web);
  const isParent = membership?.role === "player" && (data?.parent_team_ids ?? []).includes(membership?.team_id);
  return { loading, isParent, isPlayer: membership?.role === "player" && !isParent && !loading };
}
